import React from "react";
import { SearchResultsHeaderRow } from "../header/SearchResultsHeaderRow";
import { ResultsScrollbar } from "./ResultsScrollbar";
import { TableWrapper } from "./TableWrapper";
import { tableGroupsType, tableSubGroupTitleRenderer } from "../../../../common/types/search/search";
import { columnsVisibleType, resultRenderConfigType, rowGeneratorType } from "../../../../common/types/search/results";

export interface TableGroupProps {
	additionalClasses?: string;
	columnsVisible: columnsVisibleType;
	groupKey: string;
	groups: tableGroupsType;
	forPrint?: boolean;
	resultRenderConfig: resultRenderConfigType;
	rowGenerator: rowGeneratorType;
	subGroupTitleRenderer: tableSubGroupTitleRenderer;
}

export function TableGroup({
	additionalClasses,
	columnsVisible,
	groupKey,
	groups,
	forPrint,
	resultRenderConfig,
	rowGenerator,
	subGroupTitleRenderer,
}: TableGroupProps) {
	if (!groups) {
		return null;
	}

	const { columnHeaderGenerator, columnCellGenerator } = resultRenderConfig;

	return groups.map((group, index) => {
		const title = subGroupTitleRenderer(group);
		const items = group.get(groupKey);

		return (
			<TableWrapper key={index} title={title} forPrint={forPrint}>
				<ResultsScrollbar
					forPrint={forPrint}
					tableClass={additionalClasses}
				>
					<table>
						<SearchResultsHeaderRow
							columnsVisible={columnsVisible}
							columnHeaderGenerator={columnHeaderGenerator}
						/>
						<tbody>
							{rowGenerator(
								group,
								items,
								columnsVisible,
								columnCellGenerator,
							)}
						</tbody>
					</table>
				</ResultsScrollbar>
			</TableWrapper>
		);
	});
}
